import { gql } from '@apollo/client';

export const UPSERT_COMMUNITY_TOPIC = gql`
  mutation UpsertCommunityTopic($communityId: ID!, $topicName: String!, $input: UpsertTopicInput!) {
    upsertCommunityTopic(communityId: $communityId, topicName: $topicName, input: $input) {
      name
      humanModerationAssignedTtlInSeconds
      maxCasesPerModerator
      humanModerationCasesSlaInSeconds
      isStrikeEnabled
    }
  }
`;
